module.exports = __webpack_public_path__ + "static/img/QA.c27a7fdb.svg";